import {Component} from '@angular/core';

@Component({
  selector: 'privacy',
  templateUrl: 'privacy.html'
})
export class PrivacyPage {
  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/pages/privacy/privacy.ts